export const CATEGORY_NAME_MIN_LENGTH = 3;

export const CATEGORY_NAME_MAX_LENGTH = 40;
